import React from 'react'
import PropTypes from 'prop-types'

import MainLayout, { Row } from '../../layouts/Main'
import { PageTitle } from '../../components'
import { container as Bibliography } from '../../modules/Bibliography'
import media from '../../media'
import './styles.css'

const BibliographyView = () => {
    return (
        <MainLayout>
            <Row>
                <div className="col">
                    <PageTitle>Библиография</PageTitle>
                </div>
            </Row>
            <Bibliography/>
        </MainLayout>
    )
}

BibliographyView.propTypes = {
    
}

export default BibliographyView



// WEBPACK FOOTER //
// ./src/views/Bibliography/index.js